export default __webpack_public_path__ + "static/media/oldfog.f31033b5.png";